<template>
	<div class="content">
		<div class="content__row">
			<div class="content__column content__column--wide">
				<h1 class="content__title">Órdenes creadas</h1>
			</div>
		</div>
		<div class="content__row">
			<order-list :filters="filters"></order-list>
			<order-view :order="order" v-if="orderAction === 'view' && order"></order-view>
			<div class="content__column content__column--small">
				<h1 class="content__title">Opciones</h1>
				<div class="information">
					<h2 class="content__subtitle">Filtro</h2>

					<div class="form__container">
						<label for="search" class="form__label">búsqueda Libre</label>
						<input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters" />
					</div>
				</div>
			</div>
		</div>
		<button @click.prevent="newOrder" class="btn btn__add">Agregar</button>
	</div>
</template>

<script>
import httpService from '@/core/api/request'
import orderList from './list'
import orderView from './view'
import Mixins from './mixins'
export default {
	mixins: [httpService, Mixins],
	components: {
		orderList,
		orderView
	},
	data: function() {
		return {
			key: 0,
			search: null,
			status_id: null,
			filters: undefined,
			orderAction: null,
			order: null
		}
	},
	mounted: function() {
		this.$on('view', id => {
			this.getOrder(id, 'view')
		})
		this.$on('edit', id => {
			this.getOrder(id, 'edit')
		})
	},
	methods: {
		// TODO: CREAR UN FILTRO POR ESTATUS DE LA ORDEN
		setFilters: function() {
			let filter = ''
			if (this.search && this.search.length > 1) {
				filter = filter + '&search=' + this.search
			}
			filter = filter.replace(/(^&+|&+$)/, '')
			if (filter.length > 0) {
				this.filters = filter
			} else {
				this.filters = undefined
			}
		},
		getOrder: function(id, action) {
			this.orderAction = action
			let httpRequest = {
				params: '?embed=products',
				module: 'orders'
			}
			this.getById(id, httpRequest).then(order => {
				order.data.date_created = new Date(order.data.date_created)
				this.order = order.data
			})
		},
		newOrder: function() {
			this.order = undefined
			this.key = ++this.key
			this.orderAction = 'edit'
		}
	}
}
</script>

<style lang="sass">
@import "../../assets/sass/components/_home"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/orders/orders.vue